const preType = 'MESSAGES_';

export const MessagesActionTypes = {
  GET_MESSAGES_LIST: `${preType}GET_MESSAGES_LIST`,
  SET_MESSAGES_LIST: `${preType}SET_MESSAGES_LIST`,
  SET_MESSAGES_AS_READ: `${preType}SET_MESSAGES_AS_READ`,
  GET_EXTENDED_MESSAGE_LIST: `${preType}GET_EXTENDED_MESSAGE_LIST`,
  SET_INITIAL_STATE: `${preType}SET_INITIAL_STATE`,
};

const getMessagesList = () => ({ type: MessagesActionTypes.GET_MESSAGES_LIST });
const setMessagesAsRead = (data: {ids: Array<string>}) => ({ type: MessagesActionTypes.SET_MESSAGES_AS_READ, data: data });
const getExtendedMessagesList = () => ({ type: MessagesActionTypes.GET_EXTENDED_MESSAGE_LIST });
const setInitialState = () => ({ type: MessagesActionTypes.SET_INITIAL_STATE });

export const MessagesActions = {
  getMessagesList: getMessagesList,
  setMessagesAsRead: setMessagesAsRead,
  getExtendedMessagesList: getExtendedMessagesList,
  setInitialState: setInitialState,
};

